import "@Styles/Pages/Product/pdp_sm.less";
import "@Styles/Pages/Product/PB/pdp_sm.less";
import "@Styles/Pages/Product/pdp_md.less";
import "@Styles/Pages/Product/pdp_lg.less";
import actionToolbar from '@Shared/ActionToolbar/Scripts/actionToolbar';
import imageCarousel from '@Shared/ProductInfo/Scripts/imageCarousel';
import productRomanceCopy from '@Shared/ProductInfo/Scripts/productRomanceCopy';
import imageModal from '@Shared/ProductInfo/Scripts/imageModal';
import thirdPartyScript from '../../Controls/ThirdPartyScript/thirdPartyScript';

var relatedContent = function relatedContent() {
  return import(
  /* webpackChunkName: "relatedContent" */
  '@Shared/RelatedContent/Scripts/relatedContent');
};

var brandingHeader = function brandingHeader() {
  return import(
  /* webpackChunkName: "brandingHeader" */
  '@Shared/NativeAds/Scripts/brandingHeader');
};

(function () {
  GeneralMills.PandoSites.RegisterModules({
    actionToolbar: actionToolbar,
    relatedContent: relatedContent,
    productRomanceCopy: productRomanceCopy,
    thirdPartyScript: thirdPartyScript,
    imageCarousel: imageCarousel,
    imageModal: imageModal,
    brandingHeader: brandingHeader
  });
})();